import React from 'react';
import { Wrapper, Image, Headline, Text, SelectButton } from './index.styles';

export const NotFound: React.FC = () => {
    const redirectToSelection = () => {
        window.location.href = '/kredity/onlajn-zayavka-na-kredit/';
    };

    return (
        <Wrapper>
            <Image loading="lazy" src={require('../../../public/resources/selection/icons/page.scared.svg')} />
            <Headline>Страница не&nbsp;найдена</Headline>
            <Text>
                К сожалению, мы не смогли восстановить вашу анкету на кредит, но&nbsp;вы&nbsp;все равно можете подобрать
                лучшее предложение по кредиту.
            </Text>
            <SelectButton onClick={redirectToSelection} size={52}>
                Подобрать кредит
            </SelectButton>
        </Wrapper>
    );
};
